import { all } from 'redux-saga/effects';
import ClientSaga from '../containers/client/sagas';

import PriceboardSaga from '../containers/banggia/sagas';
import CashSaga from '../containers/cash/sagas';
import SummarySaga from '../containers/summary/sagas';
import CustomerSaga from '../containers/customer/sagas';
import PrivDataSaga from '../containers/privData/sagas';
import MarketSaga from 'containers/market/sagas';

import LoginSaga from '../components/modal/login/sagas';
import AuthenSaga from '../components/modal/auth/sagas';
import ResetPassSaga from '../components/modal/resetPass/sagas';
import OrdCondSaga from '../components/modal/ordCond/sagas';
import StockDetailSaga from '../components/modal/stockDetail/sagas';

export default function* IndexSaga() {
  yield all([
    ClientSaga(),
    LoginSaga(),
    AuthenSaga(),
    ResetPassSaga(),
    OrdCondSaga(),
    StockDetailSaga(),
    PriceboardSaga(),
    CashSaga(),
    SummarySaga(),
    CustomerSaga(),
    PrivDataSaga(),
    MarketSaga(),
  ]);
}
